"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children", "fields", "isValid", "method", "noValidate", "requiredIndicatorText", "requiredIndicatorTextClassName"];
/* eslint-disable complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * An opinionated form element that is designed to work the FormContainer component. When used with FormContainer as its
 * parent, Form will pass fields and isValid through to its children.
 *
 * If any fields are required, a message will be added to the top of the form indicating the requirement to the user.
 */
var Form = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _Object$values$filter, _Object$values;
  var children = _ref.children,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? {} : _ref$fields,
    isValid = _ref.isValid,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'post' : _ref$method,
    _ref$noValidate = _ref.noValidate,
    noValidate = _ref$noValidate === void 0 ? true : _ref$noValidate,
    _ref$requiredIndicato = _ref.requiredIndicatorText,
    requiredIndicatorText = _ref$requiredIndicato === void 0 ? 'indicates required field' : _ref$requiredIndicato,
    _ref$requiredIndicato2 = _ref.requiredIndicatorTextClassName,
    requiredIndicatorTextClassName = _ref$requiredIndicato2 === void 0 ? '' : _ref$requiredIndicato2,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var requiredInputList = (_Object$values$filter = (_Object$values = Object.values(fields)) === null || _Object$values === void 0 ? void 0 : _Object$values.filter(function (field) {
    var _field$input;
    return field === null || field === void 0 || (_field$input = field.input) === null || _field$input === void 0 ? void 0 : _field$input.required;
  })) !== null && _Object$values$filter !== void 0 ? _Object$values$filter : [];
  var hasRequiredField = requiredInputList.length > 0;
  var showRequiredFieldIndicator = (hasRequiredField || (0, _isEmpty2["default"])(fields)) && (requiredIndicatorText === null || requiredIndicatorText === void 0 ? void 0 : requiredIndicatorText.length);
  return /*#__PURE__*/_react["default"].createElement("form", _extends({
    method: method,
    noValidate: noValidate,
    ref: ref
  }, otherProps), showRequiredFieldIndicator && /*#__PURE__*/_react["default"].createElement("p", {
    className: requiredIndicatorTextClassName
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "color-greenAccent"
  }, "* "), requiredIndicatorText), /*#__PURE__*/_react["default"].cloneElement(children, {
    fields: fields,
    isValid: isValid
  }));
});
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  /**
   * An object to configure fields using input `names` as the key.
   *
   * If wrapped in a FormContainer, these will be passed down automatically and do not need to be defined.
   */
  fields: _propTypes["default"].shape({
    required: _propTypes["default"].bool,
    validator: _propTypes["default"].func,
    input: _propTypes["default"].object
  }),
  /**
   * Boolean representing whether all of the form's fields pass clientside validation or not
   *
   * If using a FormContainer as the parent, FormContainer provides this value.
   */
  isValid: _propTypes["default"].bool,
  /**
   * The text that appears above the form, that describes the meaning of the required indicator on fields. If the `fields` prop is passed, the message will be shown if any `fields` are marked as required. If `fields` is not passed, the message will always be shown.
   */
  requiredIndicatorText: _propTypes["default"].string,
  /**
   * Use this prop to customize the styling for the required indicator message.
   */
  requiredIndicatorTextClassName: _propTypes["default"].string
} : {};
var _default = exports["default"] = Form;